/**
=========================================================
* Vue Argon Dashboard 2 PRO - v3.0.1
=========================================================

* Product Page: https://creative-tim.com/product/vue-argon-dashboard-pro
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { createApp } from 'vue';
import App from '@/App.vue';
import store from '@/store';
import router from '@/router';
import Vueform from '@vueform/vueform'
import vueformConfig from './../vueform.config'
import '@/assets/css/nucleo-icons.css';
import '@/assets/css/nucleo-svg.css';
import VueTilt from 'vue-tilt.js';
import VueSweetalert2 from 'vue-sweetalert2';
import ArgonDashboard from '@/argon-dashboard';
import VueAwesomePaginate from 'vue-awesome-paginate';
import '@/assets/custom_global.css';
import PrimeVue from 'primevue/config';
// import 'primevue/resources/themes/lara-light-indigo/theme.css';
// import 'primevue/resources/primevue.min.css';
import Skeleton from 'primevue/skeleton';
import MultiSelect from 'primevue/multiselect';
import Select from 'primevue/select';
import InputText from 'primevue/inputtext';
import AutoComplete from 'primevue/autocomplete';

import Aura from '@primevue/themes/aura';
// import "vue-awesome-paginate/dist/style.css";
// import 'bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';

// import firebase auth service
import { projectAuth } from '@/firebase/config';
/// fontawesome modules
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import Popper from "vue3-popper";
import Paginator from 'primevue/paginator';

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css"

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import VueApexCharts from "vue3-apexcharts";
import RadioButton from 'primevue/radiobutton';
import { getBaseUrls } from '@/utils/getBaseUrls';
import Dialog from 'primevue/dialog';

// const {sentryEnv } = getBaseUrls();

//import '@vueform/vueform/themes/bootstrap/scss/index.scss';
import {
  // Directives
  vTooltip,
  vClosePopper,
  // Components
  Dropdown,
  Tooltip,
  Menu
} from 'floating-vue'

import * as Sentry from '@sentry/vue';



library.add(fas);
library.add(far);

let appInstance;



projectAuth.onAuthStateChanged(() => {
  if (!appInstance) {
    appInstance = createApp(App);
    appInstance.use(store);
    appInstance.use(router);
    
    // if (['app', 'dev', 'localhost'].some(urlVal => window.location.hostname.includes(urlVal))) {
    //   Sentry.init({
    //     app: appInstance,
    //     dsn: process.env.VUE_APP_SENTRY_DSN || 'https://c0e44656fa4d41c96071319fb94f5913@o4509241920389120.ingest.us.sentry.io/4509241925304320',
    //     environment: sentryEnv,
    //     integrations: [
    //       Sentry.browserTracingIntegration({ router }),
    //       Sentry.replayIntegration(),
    //       Sentry.captureConsoleIntegration({
    //         levels: ['warn', 'error']
    //       }),
    //     ],
    //     debug: false,
    //     tracesSampleRate: 1.0,
    //     replaysSessionSampleRate: 0.1,
    //     replaysOnErrorSampleRate: 1.0,
    //     beforeBreadcrumb(breadcrumb) {
    //       return breadcrumb;
    //     },
        
    //     beforeSend(event) {
    //       const user = projectAuth.currentUser;
    //       const params = new URLSearchParams(window.location.search);
    //       const admin_conversation_ref = params.get('conversation_ref')
    //       const widget_conversation_ref = localStorage.getItem('visitor_connection_conversation_ref');
          
    //       // console.log('Sentry User Info:', {
    //       //   admin_conversation_ref,
    //       //   widget_conversation_ref,
    //       //   url: window.location.href
    //       // });

    //       if (user) {
    //         const conversation_ref = admin_conversation_ref || widget_conversation_ref || null;
    //         const log_source = admin_conversation_ref ? 'admin' : (widget_conversation_ref ? 'widget' : null);

    //         Sentry.setUser({
    //           id: user.uid,
    //           email: user.email,
    //           username: user.displayName || user.email,
    //         });

    //         Sentry.setTag('conversation_ref', conversation_ref);
    //         Sentry.setTag('log_source', log_source);

    //         Sentry.setContext('conversation', {
    //           ref: conversation_ref,
    //           source: log_source,
    //           user_id: user.uid
    //         });

    //         // console.log('Setting Sentry User and Tags:', {
    //         //   conversation_ref,
    //         //   log_source
    //         // });
    //       }
    //       return event;
    //     }
    //   });
    // }
    appInstance.use(Vueform, vueformConfig)
    appInstance.component('tooltip', vTooltip)
    appInstance.use(VueTilt);
    appInstance.component('apexchart', VueApexCharts)
    appInstance.use(VueSweetalert2);
    appInstance.use(PrimeVue, {
      zIndex: {
        modal: 11000,        //dialog, drawer
        overlay: 9999, 
      },
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: 'none',
      }
      }
    });
    appInstance.use(ArgonDashboard);
    appInstance.component('Skeleton', Skeleton);
    appInstance.component('Paginator', Paginator);
    appInstance.component('Select', Select);
    appInstance.component('AutoComplete', AutoComplete);
    appInstance.component('InputText', InputText);
    appInstance.component('MultiSelect', MultiSelect);
    appInstance.component('VueDatePicker', VueDatePicker);
    appInstance.component("Popper", Popper);
    appInstance.component('Dialog', Dialog);
    appInstance.component('RadioButton', RadioButton);
    appInstance.use(Toast, {
      transition: "Vue-Toastification__bounce",
      newestOnTop: false
    });
    appInstance.use(VueAwesomePaginate);


    appInstance.mount('#app');
    appInstance.component('font-awesome-icon', FontAwesomeIcon);
  }
  if (window.location.href.includes('admin')) {
    if ('Notification' in window) {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
            // console.log('Notification permission granted.');
        } else {
            // console.log('Notification permission denied.');
        }
      }).catch(error => {
        // console.error('Notification permission request error:', error);
      });
    }
  } else {
    // console.log('Not on an admin page.');
  } 
});
